export const Capitalize = (str) => {
    if (typeof str === 'string') {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    } else {
        return null
    }
}

export const parserText = (val) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = val;
    return txt.value;
}

export const id_camaba = localStorage.getItem('icmb');
export const nim = localStorage.getItem('nim');

// styling react-select 
export const stylesSelect = {
    option: (provided) => ({
        ...provided,
        color: 'black'
    }),
    control: styles => ({
        ...styles,
        height: 46,
        minHeight: 46,
    }),
};

/**
 * Converter Number to Rupiah
 * @param {Number} number
 * @returns {Text}
 *
 */
 export function convertToRupiah(number) {
    const amount = parseInt(number);
    const formatNumber = new Intl.NumberFormat(
        'id-ID',
        {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0
        }
    ).format(amount);

    return String(formatNumber);
}

export function copyText(val) {
    navigator.clipboard.writeText(val);
}